// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__u-eYs","buttons":"SendReceipts_buttons__1Bo4S","email":"SendReceipts_email__2K8d0","bookApptTitle":"SendReceipts_bookApptTitle__4lp8S"};